export default __webpack_public_path__ + "static/media/nickel-plating-icon-dark.11aa8ff4.svg";